import { ChevronRight } from 'lucide-react';
import { parseCollectionPath } from '../utils';

interface BreadcrumbProps {
  collectionPath: string | null;
  onNavigate: (path: string | null) => void;
}

export function Breadcrumb({ collectionPath, onNavigate }: BreadcrumbProps) {
  if (!collectionPath) {
    return null;
  }

  const { segments } = parseCollectionPath(collectionPath);

  const handleSegmentClick = (index: number) => {
    if (index === 0) {
      // Clicking first segment (collection) navigates to base collection
      onNavigate(segments[0].name);
    } else {
      // Build path up to clicked segment
      const pathParts: string[] = [];
      for (let i = 0; i <= index; i++) {
        if (segments[i].type !== 'document') {
          pathParts.push(segments[i].name);
        } else {
          // Include document in path
          pathParts.push(segments[i].name);
        }
      }
      // Reconstruct path: collection/doc/subcollection/doc/...
      let path = '';
      for (let i = 0; i < segments.length && i <= index; i++) {
        if (i > 0) path += '/';
        path += segments[i].name;
      }
      onNavigate(path);
    }
  };

  if (segments.length <= 1) {
    return null;
  }

  return (
    <div className="px-4 pt-4">
      <nav className="flex items-center gap-1 text-sm text-muted-foreground mb-4 px-4 py-2 bg-muted/30 rounded-md">
        {segments.map((segment, index) => (
          <div key={index} className="flex items-center gap-1">
            {index > 0 && <ChevronRight className="h-4 w-4 mx-1" />}
            <button
              onClick={() => handleSegmentClick(index)}
              className="cursor-pointer hover:text-foreground transition-colors px-1 py-0.5 rounded hover:bg-muted"
              title={
                segment.type === 'collection'
                  ? 'Collection'
                  : segment.type === 'document'
                  ? 'Document'
                  : 'Subcollection'
              }
            >
              {segment.name}
            </button>
          </div>
        ))}
      </nav>
    </div>
  );
}
